// --- SaniQ ---
import {Patient, PatientCounts} from "../../../models/Patient";
import * as PatientsConstants from '../constants';

interface CurrentPatientState {
  counts: PatientCounts;
  isFetching: boolean;
  model: Patient;
  isLocked: boolean;
}

const initialState: CurrentPatientState = {
  counts: {
    findings: 0,
    measurementTriggers: 0,
    studies: 0,
    surveys: 0,
    surveyTriggers: 0,
    tasks: 0,
    triggers: 0,
    videoConsultations: 0,
    devices: 0
  },
  isLocked: false,
  isFetching: false,
  model: {
    //FIXME(Keune): In many places we need to define "stubs" for having "empty" data when loading
    //@ts-expect-error An empty object does not implement the required attributes
    address: {},
    //FIXME(Keune): In many places we need to define "stubs" for having "empty" data when loading
    contacts: [],
    devices: [],
    //FIXME(Keune): In many places we need to define "stubs" for having "empty" data when loading
    //@ts-expect-error An empty object does not implement the required attributes
    information: {},
    //FIXME(Keune): In many places we need to define "stubs" for having "empty" data when loading
    //@ts-expect-error An empty object does not implement the required attributes
    insurance: {},
    icd10s: [],
    tags: [],
    //FIXME(Keune): In many places we need to define "stubs" for having "empty" data when loading
    //@ts-expect-error An empty object does not implement the required attributes
    vitalDatum: {},
    patientPrograms: []
  }
};

export function current(state = initialState, action): CurrentPatientState {
  switch (action.type) {
    case PatientsConstants.CLEAR:
      return {...initialState};
    case PatientsConstants.FETCH_PATIENT_STARTED:
      return {...initialState, isFetching: true};
    case PatientsConstants.FETCH_PATIENT_COMPLETED_WITHOUT_RELOAD:
      return {...state,  model: action.deserializedPatient};
    case PatientsConstants.FETCH_PATIENT_COMPLETED:
      return {...state, isFetching: false, model: action.deserializedPatient};
    case PatientsConstants.FETCH_COUNTS_COMPLETED:
      return {...state, counts: action.counts};
    case PatientsConstants.LOCK_TOGGLE:
      return {...state, isLocked: action.isLocked};
    case PatientsConstants.ADD_PATIENT_DEVICE:
      //FIXME(Keune): Implement Action ADD_PATIENT_DEVICE
      return state;
    case PatientsConstants.DELETE_PATIENT_DEVICE:
      //FIXME(Keune): Implement Action DELETE_PATIENT_DEVICE
      return state;
    case PatientsConstants.UPDATE_INSTRUCTION_SEND_AT:
      //FIXME(Keune): Implement Action UPDATE_INSTRUCTION_SEND_AT
      return state;
    default:
      return state;
  }
}
